import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from 'react';

// One stable subscribe function per interval, so React doesn't resubscribe on every render.
const subscribers = new Map<number, (onChange: () => void) => () => void>();
const subscribe = (intervalMs: number) => {
  if (!subscribers.has(intervalMs)) {
    subscribers.set(intervalMs, onChange => {
      const id = setInterval(onChange, intervalMs);
      return () => clearInterval(id);
    });
  }
  return subscribers.get(intervalMs);
};
let snapshot = Date.now();
const getSnapshot = () => {
  const now = Date.now();
  // Only hand out a new value once it has moved on, so React sees a stable snapshot.
  if (now - snapshot >= 1000) {
    snapshot = now;
  }
  return snapshot;
};

// Current time as React state, refreshed every `intervalMs`.
export function useNow(t0) {
  const $ = _c(2);
  const intervalMs = t0 === undefined ? 1000 : t0;
  let t1;
  if ($[0] !== intervalMs) {
    t1 = subscribe(intervalMs);
    $[0] = intervalMs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useSyncExternalStore(t1, getSnapshot, getSnapshot);
}